export default __webpack_public_path__ + "static/media/formRocket.2fa105a1.svg";